<template>
  <!-- PROPERTY ROOF FLAT -->
  <validation-observer
    v-slot="propertyRoofObserver"
    key="roof-flat"
    slim
  >
    <form-section
      id="property-roof-flat"
      v-bind="propertyRoofObserver"
      :validated="formObserver.validated"
    >
      <form-row
        label="Is any part of the roof flat?"
        :error="formObserver.validated && !propertyRoofObserver.valid"
      >
        <validation-provider
          v-slot="{ failed }"
          name="Property Flat Roof"
          :vid="`${stepId}_property-flat-roof`"
          :rules="{ is_not: { other: null } }"
          slim
        >
          <radio
            v-model="propertyFlatRoofModel"
            name="property-flat-roof"
            wide
            :error="failed"
            :items="constants.YES_NO"
            :data-test="snakeCase(questionFields.propertyFlatRoof)"
          />
        </validation-provider>
        <validation-provider
          v-if="isPropertyFlatRoof"
          v-slot="{ errors, failed }"
          :vid="`${stepId}_property-flat-roof`"
          name="Property Flat Roof List"
          rules="listOptionRequired"
          slim
        >
          <qz-select
            v-model.number="questionData.propertyFlatRoof"
            :items="propertyFlatRoofItemsOther"
            item-text="text"
            :error="failed"
            :error-messages="errors"
            :placeholder="helpers.getPlaceholderResponsiveText('Select approx percentage', isMobile)"
            class="mt-4"
            :data-test="`${snakeCase(questionFields.propertyFlatRoof)}_other`"
          />
        </validation-provider>
      </form-row>
      <help-text
        :error="formObserver.validated && !propertyRoofObserver.valid"
      >
        This will include any garages or outbuildings of the property.
      </help-text>
    </form-section>
  </validation-observer>
</template>

<script>
import QuestionBase from '@/components/questions/Base.vue';

import { omit } from 'lodash';

export default {
  name: 'question-property-flat-roof',
  extends: QuestionBase,
  data () {
    return {
      fields: ['propertyFlatRoof'],
    };
  },
  computed: {
    propertyFlatRoofModel: {
      get () {
        if (this.helpers.isNull(this.questionData.propertyFlatRoof)) return null;
        return this.questionData.propertyFlatRoof !== this.constants.HOME_PROPERTY_FLAT_ROOF_FAVORITES;
      },
      set (val) {
        this.questionData.propertyFlatRoof = val ? '' : this.constants.HOME_PROPERTY_FLAT_ROOF_FAVORITES;
      },
    },

    isPropertyFlatRoof () {
      return !this.helpers.isNull(this.questionData.propertyFlatRoof) && this.questionData.propertyFlatRoof !== this.constants.HOME_PROPERTY_FLAT_ROOF_FAVORITES;
    },

    propertyFlatRoofItemsOther () {
      return this.helpers.createOptions({ source: omit(this.constants.HOME_PROPERTY_FLAT_ROOF, this.constants.HOME_PROPERTY_FLAT_ROOF_FAVORITES), asNumbers: true });
    },
  },
};
</script>
